import { Button, Icon, Notice } from "../../components/design";
import "../../components/Auth/AuthForm.css";
import "./tenantCheckSteps.css";

export default function TenantChecksCompletedModal({
  tenantName,
  onGoToDashboard,
  _t,
}) {
  const name = tenantName || "Javier";
  return (
    <div className="tc-step-page">
      <div className="tc-step tc-step--center">
        <span className="tc-done-icon" aria-hidden="true">
          <Icon name="check" size={24} />
        </span>
        <h2 className="auth-step-title">
          {_t ? _t("checkCompleted", "Check completed") : "Check completed"}
        </h2>
        <p className="auth-step-sub">
          {_t
            ? _t(
                "checkCompletedSubtitle",
                "You'll find the results in your dashboard in a few minutes."
              )
            : "You'll find the results in your dashboard in a few minutes."}
        </p>
        <p className="tc-done-name">
          {_t
            ? _t(
                "youCompletedProfile",
                `You completed ${name}'s profile`,
                undefined,
                { name: name }
              )
            : `You completed ${name}'s profile`}
        </p>
        <Notice>
          {_t
            ? _t(
                "processingProfiles",
                "We're processing the profiles and we'll email you when everything is live"
              )
            : "We're processing the profiles and we'll email you when everything is live"}
        </Notice>
        <Button size="lg" block onClick={onGoToDashboard}>
          {_t
            ? _t("goToMyDashboard", "Go to my dashboard")
            : "Go to my dashboard"}
        </Button>
      </div>
    </div>
  );
}
